import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconUpload = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_upload_light"
      data-name="UI icon/upload/light"
      xmlns="http://www.w3.org/2000/svg"
      width="14.903"
      height="12.833"
      viewBox="0 0 14.903 12.833"
    >
      <path
        id="Union"
        d="M8.863,3.967A.828.828,0,1,1,7.692,5.137L5.382,2.827V8.694a.828.828,0,0,1-1.656,0V2.827L1.413,5.139A.828.828,0,0,1,.242,3.968L3.968.242a.828.828,0,0,1,1.171,0Z"
        transform="translate(2.899 0)"
        fill={color}
      />
      <path
        id="Path_13_Copy_7_Stroke_"
        data-name="Path 13 Copy 7 (Stroke)"
        d="M.828,0a.828.828,0,0,1,.828.828V2.484a.828.828,0,0,0,.828.828h9.935a.828.828,0,0,0,.828-.828V.828a.828.828,0,1,1,1.656,0V2.484a2.484,2.484,0,0,1-2.484,2.484H2.484A2.484,2.484,0,0,1,0,2.484V.828A.828.828,0,0,1,.828,0Z"
        transform="translate(0 7.866)"
        fill={color}
      />
    </svg>
  );
};

export default IconUpload;
